import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { AdminDataProvider } from './contexts/AdminDataContext';
render(<AdminDataProvider data-id="element-1422">
    <AppRouter data-id="element-1423" />
  </AdminDataProvider>, document.getElementById('root'));